export const optionsRange = [
    { value: '>=', label: 'Maior ou Igual' },
    { value: '<=', label: 'Menor ou Igual' },
];

export const patternBoolean = value => value ? 'Sim' : 'Não';
